export default function IconPrevPage({ color = "white", size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size + 6}
      viewBox="0 0 9 15"
      fill="none"
      transform="rotate(180)"
    >
      <path d="M8.5 7.5L0.249999 14.8612L0.25 0.138784L8.5 7.5Z" fill={color} />
    </svg>
  );
}
